<script lang="ts">
    import { onMount } from 'svelte';

    import {
        type SliderProps,
        sliderTelematicsSingle,
    } from '../telematics/components/Colorizer/sliderTelematicsSingle';
    import { debug } from '../../../stores/store';

    let defaultSliderProps: SliderProps = {
        min: -25,
        max: 25,
        currentValue: 0,
        unit: '%',
        dangerZoneBelowValue: 0,
        dangerZoneAboveValue: false,
        roundValues: true,
        keepInitialValueInSliderRange: true,
        inputsAboveSlider: true,
        sliderWidth: 400,
    };

    export let props: any = {};
    export let onChange: (value: number) => void = () => {};

    props = { ...defaultSliderProps, ...props };

    let div: HTMLDivElement;

    onMount(() => {
        new sliderTelematicsSingle(div, props, {
            onSliderChange: currentValue => {
                console.log('onSliderChange', currentValue);
                onChange(currentValue);
            },
        });
    });
</script>

{#if $debug}
    props:{JSON.stringify(props)}
{/if}
<div style="position: relative; min-height: 43px; padding: 20px 60px 0 60px;">
    <div bind:this={div}></div>
</div>
